"use client";

import React, {
  useState,
  useMemo,
  useRef,
  useEffect,
  useCallback,
  isValidElement,
  useContext,
} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
  Divider,
  useMediaQuery,
  useTheme,
  Modal,
  Icon,
} from "@mui/material";
import {
  promoRuleOptions,
  promotionCreteria,
  updateRuleValue,
  userGroups,
  validateSelectedValues,
  validRuleFields,
} from "./data";
import { rulesStructure } from "./promotionRuleDefinitions";
import EditIcon from "common/customIcons/edit";
// import DeleteIcon from "../../../../../components/CustomIcons/delete";
import { useDispatch, useSelector } from "react-redux";
import { cloneDeep, isEmpty } from "lodash";
// import { getUserGroups } from "../../../../../redux/features/products/productSlice";
import ThenRuleView from "./ThenRuleView";
import IfRuleView from "./IfRuleView";
import SouthIcon from "@mui/icons-material/South";
import CommonLayout from "layouts/DashboardLayout";
import PromotionRuleFormattedText from "./PromotionRuleFormattedText";
import { getAllBlazeCategory, getAllCategory } from "../../redux/slices/hyperwolf/products";
import DeleteIcon from "common/customIcons/delete";
import CloseIcon from "@mui/icons-material/Close";
import PromotionRuleTable from "./PromotionRuleTable";
import { useParams } from "react-router-dom";
import MDButton from "components/MDButton";
import { PlatformContext } from "./AddPromotions";
import { getPlatformCategory } from "../../redux/slices/promotions";

export function PromotionRule({ data, setData, formData, setFormData }) {
  const [show, setShow] = useState(false);
  // const [data, setData] = useState({
  //   ruleType: "",
  //   ifRules: [],
  //   thenRules: [],
  // });

  const platform = useContext(PlatformContext);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isMenuHappenOpen, setMenuHappenOpen] = useState(false);
  const [thenRuleOpen, setThenRuleOpen] = useState(false);
  const [isThenMenuHappenOpen, setThenMenuHappenOpen] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const [creteriaError, setCreteriaError] = useState(false);
  const [creteria, setCreteria] = useState("");
  const { promoId } = useParams();
  const dispatch = useDispatch();

  const updateRulesRef = useRef({
    ruleType: "",
    ifRules: [],
    thenRules: [],
  });
  const selectedRuleTypeRules = useMemo(() => {
    return cloneDeep(rulesStructure?.[data.ruleType]?.[creteria]) || [];
  }, [data.ruleType, creteria]);
  const selectedThenRuleTypeRules = useMemo(() => {
    const rules = rulesStructure?.[data.ruleType];
    if (rules && creteria && rules[creteria]) {
      // Some ruleTypes (e.g. "user") define global `thenRules` at the ruleType level,
      // while criteria nodes can have empty `thenRules`. In that case, fall back to global.
      const scoped = cloneDeep(rules[creteria]);
      const globalThenRules = cloneDeep(rules?.thenRules || []);
      return {
        ...scoped,
        thenRules:
          Array.isArray(scoped?.thenRules) && scoped.thenRules.length > 0
            ? scoped.thenRules
            : globalThenRules,
      };
    }
    return cloneDeep(rules) || [];
  }, [data.ruleType, creteria]);

  useEffect(() => {
    return () => {
      updateRulesRef.current = {
        ruleType: "",
        ifRules: [],
        thenRules: [],
      };
      setData({
        ruleType: "",
        ifRules: [],
        thenRules: [],
      });

      setCreteria("");
    };
  }, []);
  useEffect(() => {
    if (promoId) setCreteria(formData?.rules?.creteria);
  }, [promoId, formData.rules]);

  useEffect(() => {
    updateRulesRef.current = data;
  }, [data]);

  const filters = {
    skip: 0,
    limit: 10,
    searchTerm: "",
    platform: platform,
  };

  // dispatch(getAllCategory())
  useEffect(() => {
    dispatch(
      getPlatformCategory({
        skip: filters?.skip,
        limit: filters?.limit,
        platform: platform,
        searchTerm: filters?.searchTerm || "",
      })
    )
      .unwrap()
      .then((res) => {
        const { data, total } = res;

        const categoryData = data?.map((item) => {
          return {
            categoryId: item?.categoryId,
            categoryName: item?.categoryName,
            categorySlug: item?.categorySlug,
            status: item?.status,
          };
        });

        setAllCategories(categoryData);
      })
      .catch((err) => {
        console.error(err);
      });
    dispatch(getAllBlazeCategory());
  }, [dispatch]);

  const deleteRuleHandler = () => {
    setData({
      ruleType: "",
      ifRules: [],
      thenRules: [],
    });
    setCreteria("");
  };

  const memoizeCategoryList = useMemo(() => {
    return allCategories?.map((item) => ({
      // title: category?.name,
      // value: category.id,

      categoryId: item?.categoryId,
      categoryName: item?.categoryName,
      categorySlug: item?.categorySlug,
      status: item?.status,
    }));
  }, [allCategories]);

  const getCategoryById = useCallback(
    (categoryId) => {
      return memoizeCategoryList.find((item) => item.categoryId === categoryId);
    },
    [memoizeCategoryList]
  );

  const memoizeUserGroups = useMemo(() => {
    return userGroups?.map((group) => ({
      title: group?.name,
      value: group.id,
    }));
  }, [userGroups]);

  const getGroupById = useCallback(
    (groupId) => {
      return memoizeUserGroups.find((item) => item.value === groupId);
    },
    [memoizeUserGroups]
  );

  const validateFields = () => {
    let newData = validateSelectedValues(updateRulesRef.current);
    newData = {
      ...newData,
      showError: newData.ifRules.length === 0,
      showThenError: newData.thenRules.length === 0,
      isRuleSelected: newData.ruleType === "",
    };
    updateRulesRef.current = newData;
    setData(cloneDeep(newData));
  };

  const onCreateRule = () => {
    validateFields();

    // Check if If rules exist but Then rules are missing
    if (updateRulesRef.current?.ifRules?.length > 0 && updateRulesRef.current?.thenRules?.length === 0) {
      setData(prev => ({ ...prev, showThenError: true }));
      return;
    }

    if (updateRulesRef.current?.ifRules?.length === 0) {
      setData(prev => ({ ...prev, showError: true }));
      return;
    }

    if (!creteria) {
      setCreteriaError(true);
      return;
    }

    // Validating specific fields within the rules
    const isValidRule = validRuleFields(updateRulesRef.current);
    if (!isValidRule) {
      return;
    }

    // Save the validated ref (has latest ifRules/thenRules including groupRule values like view count, upto)
    setFormData((prev) => ({ ...prev, rules: { ...updateRulesRef.current } }));
    setShow(false);
  };

  const orderTotalExeedValue = useMemo(() => {
    return Number(
      data?.ifRules?.find((rule) => rule?.value === "total_exceeds")?.selectedValue || 0
    );
  }, [data]);

  // useEffect(() => {
  //   dispatch(getAllCategories());
  //   dispatch(getUserGroups());
  // }, []);

  // useEffect(() => {
  //   if (!isEmpty(rulesData)) {
  //     setData(rulesData);
  //   }
  // }, [rulesData]);

  const hasLocalRuleData =
    !!data?.ruleType ||
    (Array.isArray(data?.ifRules) && data.ifRules.length > 0) ||
    (Array.isArray(data?.thenRules) && data.thenRules.length > 0);

  const hasSavedRuleData = formData?.rules && Object.keys(formData.rules).length > 0;

  console.log(data, formData, "ruless");
  return (
    <>
      {isEmpty(formData?.rules) ? (
        <MDButton
          sx={{ minWidth: "240px" }}
          type="button"
          variant="outlined"
          color="primary"
          onClick={() => {
            setShow(!show);
            setData({
              ruleType: "",
              ifRules: [],
              thenRules: [],
            });
          }}
        >
          <Icon>add</Icon>&nbsp;Add Promotion Rule
        </MDButton>
      ) : (
        <Box display="flex" alignItems="center" justifyContent="space-between" gap={2} mt={1} 
          style={{ background: "#f7f7f7", borderRadius: "12px", padding: "20px" }}
        >
          {!show && formData?.rules?.ifRules?.length > 0 && (
            <PromotionRuleFormattedText
              ruleSet={formData.rules}
              deleteHandler={deleteRuleHandler}
              allCategories={memoizeCategoryList}
              userGroups={memoizeUserGroups}
            />
          )}
          <Box display="flex" alignItems="flex-start" justifyContent="flex-end" gap={1}>
            <IconButton
              color="primary"
              size="small"
              variant="primary"
              onClick={() => {
                setShow(!show);
                setData({
                  ruleType: formData?.rules?.ruleType || "",
                  ifRules: formData?.rules?.ifRules ? [...formData.rules.ifRules] : [],
                  thenRules: formData?.rules?.thenRules ? [...formData.rules.thenRules] : [],
                  creteria: formData?.rules?.creteria || "",
                  isRuleSelected: formData?.rules?.isRuleSelected || false,
                  showError: formData?.rules?.showError || false,
                  showThenError: formData?.rules?.showThenError || false,
                });
              }}
            >
              <EditIcon width="16px" height="16px" />
            </IconButton>
            <IconButton
              color="error"
              size="small"
              variant="primary"
              onClick={(e) => {
                setFormData((prev) => ({ ...prev, rules: "" }));
              }}
            >
              <DeleteIcon width="16px" height="16px" />
            </IconButton>
          </Box>
        </Box>
      )}

      <Dialog
        open={show}
        // onClose={() => setShow(!show)}
        // fullScreen={fullScreen}
        maxWidth="xl"
        fullWidth
        className="promotion-rule-modal"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2,
            pr: 2,
          }}
        >
          <Typography variant="h6">Promotion Rule</Typography>
          <IconButton onClick={() => setShow(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box
            sx={{
              display: "flex",
              py: 2,
              px: 3,
              position: "relative",
              minHeight: "300px",
            }}
          >
            <Box sx={{ flexGrow: 1 }}>
              {/* if rules */}
              <Box
                sx={{
                  color: "text.secondary",
                  fontWeight: 500,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <IfRuleView
                    data={data}
                    formData={formData}
                    setData={setData}
                    thenRuleOpen={thenRuleOpen}
                    setThenRuleOpen={setThenRuleOpen}
                    rulesStructure={rulesStructure}
                    selectedRuleTypeRules={selectedRuleTypeRules}
                    isThenMenuHappenOpen={isThenMenuHappenOpen}
                    setThenMenuHappenOpen={setThenMenuHappenOpen}
                    updateRulesRef={updateRulesRef}
                    updateRuleValue={updateRuleValue}
                    setMenuOpen={setMenuOpen}
                    isMenuOpen={isMenuOpen}
                    dropdownItems={promoRuleOptions}
                    setMenuHappenOpen={setMenuHappenOpen}
                    isMenuHappenOpen={isMenuHappenOpen}
                    getCategoryById={getCategoryById}
                    getGroupById={getGroupById}
                    memoizeCategoryList={memoizeCategoryList}
                    memoizeUserGroups={memoizeUserGroups}
                    creteria={creteria}
                    setCreteria={setCreteria}
                    creteriaError={creteriaError}
                    setCreteriaError={setCreteriaError}
                  />
                </Box>
                {/* <PromotionRuleFormattedText
                    ruleSet={data?.ifRules || {}}
                    isActionsAllow={false}
                    showTooltip={true}
                    className="truncate line-3"
                  /> */}
                {(hasSavedRuleData || hasLocalRuleData) && (
                  <IconButton
                    onClick={() => deleteRuleHandler()}
                    color="error"
                    size="small"
                    variant="primary"
                    style={{ height: "16px" }}
                  >
                    <DeleteIcon width="16px" height="16px" />
                  </IconButton>
                )}
              </Box>

              <Box sx={{ color: "primary.main", my: 1, pt: 1, textAlign: "start" }}>
                <SouthIcon />
              </Box>
              <ThenRuleView
                data={data}
                thenRuleOpen={thenRuleOpen}
                setThenRuleOpen={setThenRuleOpen}
                rulesStructure={rulesStructure}
                setData={setData}
                selectedRuleTypeRules={selectedThenRuleTypeRules}
                isThenMenuHappenOpen={isThenMenuHappenOpen}
                setThenMenuHappenOpen={setThenMenuHappenOpen}
                updateRulesRef={updateRulesRef}
                updateRuleValue={updateRuleValue}
                orderTotalExeedValue={orderTotalExeedValue}
              />
            </Box>
          </Box>{" "}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="contained"
            onClick={onCreateRule}
            sx={{
              background: "#0163FF",
              color: "#ffffff",
              minWidth: "165px",
              border: "1px solid #0163FF",
            }}
          >
            {formData?.rules?.ifRules?.length > 0 ? "Update Rule" : "Create Rule"}
            {/* create rule */}
          </Button>
          <Button
            sx={{
              color: "#2E2E3A !important",
              border: "1px solid #2E2E3A",
              minWidth: "150px",
              background: "#ffffff",
            }}
            onClick={() => setShow(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
